import type { BranchSearch, BranchSearchDto } from '../types';

export function branchSearchFromDto(dto: BranchSearchDto): BranchSearch {
  return {
    id: dto.id,
    short: dto.bran_short,
    name: dto.bran_name,
    workplace: dto.bran_workplace,
    fulltimeWorkingHours: dto.bran_fulltime_working_hours,
  };
}
